import type { HTMLProps } from 'react';
import React from 'react';

import styles from './Datagrid.module.scss';

export type DatagridProps = { colCount: number; rowCount: number } & HTMLProps<HTMLDivElement>;

const Datagrid: React.FC<DatagridProps> = ({ children, colCount, rowCount, ...props }) => (
	<div aria-colcount={colCount} aria-rowcount={rowCount} className={styles.datagrid} role="grid" {...props}>
		{children}
	</div>
);

export default Datagrid;
